<h2 mat-dialog-title>Confirm Delete</h2>
<div mat-dialog-content class="confirmation-dialog__message">
  {{message}}
</div>
<div mat-dialog-actions>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="onNoClick()" cdkFocusInitial>No</button>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" [mat-dialog-close]="true" >Yes</button>
</div>
